import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { CoursesService } from 'src/providers/courses.service';
import SwiperCore, { Autoplay } from 'swiper';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { JSONIDService } from 'src/providers/schema';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DashboardService } from 'src/providers/dashboard.service';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { MatDialog } from '@angular/material/dialog';

SwiperCore.use([Autoplay]);

declare var $:any;

@Component({
  selector: 'app-iit-design',
  templateUrl: './iit-design.component.html',
  styleUrls: ['./iit-design.component.scss']
})



export class IitDesignComponent implements OnInit {

  NID: any[] = [
    { img: 'https://media.iquanta.in/ui_images/idesign/nid-topper-1.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nid-topper-2.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nid-topper-3.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nid-topper-4.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nid-topper-5.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nid-topper-6.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nid-topper-7.webp', },

  ];

  UCEED: any[] = [
    { img: 'https://media.iquanta.in/ui_images/idesign/uceed-topper-1.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/uceed-topper-2.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/uceed-topper-3.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/uceed-topper-4.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/uceed-topper-5.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/uceed-topper-6.webp', },
  ];

  CEED: any[] = [
    { img: 'https://media.iquanta.in/ui_images/idesign/ceed-topper-1.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/ceed-topper-2.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/ceed-topper-3.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/ceed-topper-4.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/ceed-topper-5.webp', },
  ];

  NIFT: any[] = [
    { img: 'https://media.iquanta.in/ui_images/idesign/nift-topper-1.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nift-topper-2.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nift-topper-3.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nift-topper-4.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nift-topper-5.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nift-topper-6.webp', },
    { img: 'https://media.iquanta.in/ui_images/idesign/nift-topper-7.webp', },
  ];

  config: any = {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      }
    }
  };
  counsellingForm!: FormGroup;


  collageList: any[] = [
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-1.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-2.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-3.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-4.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-5.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-6.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-7.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-8.webp' },
    { image: 'https://media.iquanta.in/ui_images/idesign/idesign-clg-9.webp' }
  ]


  viewCount: any = 16;
  viewCount1: any = 16;
  viewCount2: any = 16;
  viewCount3: any = 24;
  viewCount4: any = 24;
  viewCount5: any = 24;
  viewCount6: any = 24;
  viewCount7: any = 24;
  viewCount8: any = 24;
  viewMore(val: any) {
    if (val == '1') {
      if (this.viewCount < this.NID.length) {
        this.viewCount = this.viewCount + 24;
      }
    } else if (val == '2') {
      if (this.viewCount1 < this.UCEED.length) {
        this.viewCount1 = this.viewCount1 + 24;
      }
    } else if (val == '3') {
      if (this.viewCount2 < this.CEED.length) {
        this.viewCount2 = this.viewCount1 + 24;
      }
    }
    else if (val == '4') {
      if (this.viewCount2 < this.NIFT.length) {
        this.viewCount2 = this.viewCount1 + 24;
      }
    }

  }

  ngAfterViewInit() {
    this.iniSlickJs()
  }


  iniSlickJs() {
    // const htmlScriptElement2 = document.createElement('script');
    // htmlScriptElement2.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    // this.elementRef.nativeElement.appendChild(htmlScriptElement2);
    const htmlScriptElement3 = document.createElement('script');
    htmlScriptElement3.src = '../../assets/js/home-swiper.js';
    htmlScriptElement3.setAttribute('async', '')
    this.elementRef.nativeElement.appendChild(htmlScriptElement3);
  }


  viewLess(val: any) {
    if (val == '1') {
      this.viewCount = 24;
    } else if (val == '2') {
      this.viewCount1 = 24;
    } else if (val == '3') {
      this.viewCount2 = 24;
    } else if (val == '4') {
      this.viewCount3 = 24;
    } else if (val == '5') {
      this.viewCount4 = 24;
    } else if (val == '6') {
      this.viewCount5 = 24;
    } else if (val == '7') {
      this.viewCount6 = 24;
    } else if (val == '8') {
      this.viewCount7 = 24;
    } else if (val == '9') {
      this.viewCount8 = 24;
    }

  }

  gotosection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
    if (val == 'courses') {
      this.activeCourseTab = 'Flagship'
    }
  }
  yearFilter: any = '2024';
  coursesArray: any[] = []
  evenArray: any[] = [];
  oddArray: any[] = [];
  activeCourseTab: any;
  selectedCourses: any[] = [];


  json1: any;


  constructor(public coursesService: CoursesService, private titleService: Title, private metaService: Meta, @Inject(DOCUMENT) private dom: any, public homeSrvice: JSONIDService,
    public formBuilder: FormBuilder, public matSnackBar: MatSnackBar, public dashboardService: DashboardService, public elementRef: ElementRef,
  @Inject(LOCAL_STORAGE) public sessionStorage: any, public deviceService: DeviceDetectorService, public dialog: MatDialog) { }
  ngOnInit(): void {
    this.getHomePageCourses('iDesign', 'landingpage')

    this.json1 = this.homeSrvice.iDesignBreadcrumb;
    // Meta Data
    this.titleService.setTitle("iDesign: Best Design Online Course by iQuanta");
    this.metaService.updateTag(
      { name: 'description', content: "iQuanta is the one stop solution for the best design online course for NID, NIFT, IIT-UCEED, IIT-CEED, NATA, and IIT-BArch in India. With more than 850+ students who have successfully cracked." });
    this.metaService.updateTag(
      { name: 'keywords', content: 'Design course,Design Online Course,Design Online coaching,Design coaching' });
    // Canonical Link
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
    head.appendChild(element);
    element.setAttribute('rel', 'canonical')
    element.setAttribute('href', 'https://www.iquanta.in/idesign')
    // Facebook
    this.metaService.updateTag(
      { property: 'og:type', content: "website" })
    this.metaService.updateTag(
      { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
    this.metaService.updateTag(
      { property: 'og:title', content: "iDesign: Best Design Online Course by iQuanta" })
    this.metaService.updateTag(
      { property: 'og:url', content: 'https://www.iquanta.in/idesign' })
    this.metaService.updateTag(
      { property: 'og:description', content: "iQuanta is the one stop solution for the best design online course for NID, NIFT, IIT-UCEED, IIT-CEED, NATA, and IIT-BArch in India. With more than 850+ students who have successfully cracked." });
    this.metaService.updateTag(
      { property: 'og:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'og:image:width', content: '1280' })
    this.metaService.updateTag(
      { property: 'og:image:type', content: 'image/png' })
    this.metaService.updateTag(
      { property: 'og:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2025/04/idesign.png' })
    // Article Publish Time
    this.metaService.updateTag(
      { property: 'article:published_time', content: '2025-04-16T10:48:33+00:00' })
    // Twitter
    this.metaService.updateTag(
      { property: 'twitter:label2', content: "Est. reading time" })
    this.metaService.updateTag(
      { property: 'twitter:data2', content: "6 Minutes" })
    this.metaService.updateTag(
      { property: 'twitter:title', content: "iDesign: Best Design Online Course by iQuanta" })
    this.metaService.updateTag(
      { property: 'twitter:url', content: 'https://www.iquanta.in/idesign' })
    this.metaService.updateTag(
      { property: 'twitter:description', content: "iQuanta is the one stop solution for the best design online course for NID, NIFT, IIT-UCEED, IIT-CEED, NATA, and IIT-BArch in India. With more than 850+ students who have successfully cracked." });
    this.metaService.updateTag(
      { property: 'twitter:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2025/04/idesign.png' })
    this.metaService.updateTag(
      { property: 'twitter:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'twitter:image:type', content: 'image/png' })
    this.metaService.updateTag(
      { property: 'twitter:image:width', content: '1280' })

    this.counsellingForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      course: ['', Validators.required]
    })


  }

  addInternalCRMLead(typ: any) {
    this.selectedCategory.forEach((cat: any) => {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "name": this.counsellingForm.value.name,
        "firstName":this.counsellingForm.value.name,
        "phone": this.counsellingForm.value.mobile,
        "email": this.counsellingForm.value.email,
        "countryCode": 91,
        "source": "Website",
        "medium": "iDesign Landing Page",
        "campaign": typ ? typ : 'iDesign Lead Form',
        "orgId": "6802531e711989d32d1e2b2c",
        "uid": '6802531e711989d32d1e2b2c',
        "userId":  9999,
        "registrationDate":new Date().valueOf(),
        "pageLocation": this.dom.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
        "registrationDevice": this.deviceService.deviceType,
        "customFields": {
          "exam": this.counsellingForm.value.course,
          "examCategory": 'iDesign',
          "examTargetYear":  2026,
          "leadPriority": "Platinum",
        },
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "source": "Website",
            "medium": "iDesign",
            "campaign": typ ? typ : 'iDesign Lead Form',
            adContent: "",
            "pageLocation": this.dom.URL,
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
          this.selectedCategory = [];
          this.counsellingForm.reset()
        } else {
          this.selectedCategory = [];
          this.counsellingForm.reset()

        }
      }, err => {
        if (err.statusText == 'Unknown Error') {
          this.callBackLead(reqObj)
        }
      })
    })
  }

  callBackLead(reqObj: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {
      this.selectedCategory = [];
    })
  }

  selectedCategory:any[]=[]
  submit(typ:any){
    if (this.counsellingForm.valid) {
      let reqObj = {
        name: this.counsellingForm.value.name,
        email: this.counsellingForm.value.email,
        phone_no: this.counsellingForm.value.mobile,
        course: this.counsellingForm.value.course,
        year: '2026',
        time_slot: '',
      }

      this.coursesService.homeEnquiry(reqObj).subscribe(res => {
        if (res.success || res.id) {
          this.selectedCategory.push('iDesign')
          this.addInternalCRMLead(typ)
          $('#ChooseEquiry').modal('hide')
         const dialogRef = this.dialog.open(ThanksDialogueComponent, {
                    width: '330px',
                    panelClass: 'thanks-modal'
        
                  })
                  dialogRef.afterClosed().subscribe(res => {
                    location.reload()
                  })
        } else {

        }
      }, err => {
        this.matSnackBar.open(err.error.error, 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      })
    }
    else {
      if (this.counsellingForm.controls['name'].hasError('required')) {
        this.matSnackBar.open('Name is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('required')) {
        this.matSnackBar.open('Email is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('required')) {
        this.matSnackBar.open('Phone Number is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['course'].hasError('required')) {
        this.matSnackBar.open('Course is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['year'].hasError('required')) {
        this.matSnackBar.open('Target Year is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['course'].hasError('required')) {
        this.matSnackBar.open('Course is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('pattern')) {
        this.matSnackBar.open('Email is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('pattern')) {
        this.matSnackBar.open('Phone Number is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
    }
  }

  getHomePageCourses(val: any, type: any) {
    this.coursesArray = [];
    this.evenArray = [];
    this.oddArray = []
    this.activeCourseTab = val;
    this.coursesService.getPagewiseCourses(val, type, '2024').subscribe(res => {
      if (res.success) {
        if (res.data.length > 0) {
          this.coursesArray = res.data[0].course.filter((x: any) => !x.is_rq);
          this.coursesArray.forEach((course: any, index: any) => {
            if (0 === index % 2) {
              this.evenArray.push(course)
            } else {
              this.oddArray.push(course)
            }
          })
        }

      }
    })
  }

  changeYear(ev: any) {
    if (this.yearFilter == '2025') {
      this.yearFilter = '2026'
    } else {
      this.yearFilter = '2025'
    }
    this.getHomePageCourses('iDesign', 'landingpage')
  }
}
